import { useState } from 'react';
import { fetchBuildDistributionExternalBucketBuilds } from '../../api';
import { ExternalBuildDistroBuild, FetchExternalBuildDistroBucketBuildsResponse } from '@/types';

export type GetExternalBucketBuildsHookResult = [
    getExternalBucketBuilds: (bucketHash: string) => Promise<FetchExternalBuildDistroBucketBuildsResponse>,
    isLoading: boolean,
    error: any,
];

export function useGetExternalBuildDistroBucketBuilds(): GetExternalBucketBuildsHookResult {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getExternalBucketBuildsFn = async (bucketHash: string) => {
        setIsLoading(true);
        try {
            const bucket: ExternalBuildDistroBuild[] = await fetchBuildDistributionExternalBucketBuilds({ bucketHash });

            return bucket;
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }

        return null;
    };

    return [getExternalBucketBuildsFn, isLoading, error];
}
